<!-- <nav aria-label="breadcrumb" class="breadcrumbs-container">
<ul
  class="breadcrumbs"
  [ngClass]="{ 'breadcrumbs-light': !isDark, 'breadcrumbs-dark': isDark }"
  >
  <li *ngFor="let breadcrumb of breadcrumbs; let last = last">
    <ng-container *ngIf="!last">
      <a *ngIf="isRouterLink(breadcrumb.url)" [routerLink]="breadcrumb.url">
        {{ breadcrumb.label }}
      </a>
      <a *ngIf="!isRouterLink(breadcrumb.url)" [href]="breadcrumb.url">
        {{ breadcrumb.label }}
      </a>
    </ng-container>
    <span *ngIf="last">{{ breadcrumb.label }}</span>
    <span *ngIf="!last">
      <span *ngIf="isArrow">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </span>
      <span *ngIf="!isArrow">/</span>
    </span>
  </li>
</ul>
</nav> -->
<div class="breadcrumb-section seven">
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="banner-content">
          <ul
            class="breadcrumb-list"
            [ngStyle]="{ 'justify-content': justify + ' !important' }"
            >
            @for (item of breadcrumbs; track item; let isLast = $last) {
              <li>
                @if (item.url && !isLast) {
                  <a
                    [attr.data-translation-key]="item.translationKey"
                    [routerLink]="item?.url"
                    [queryParams]="item?.queryParams"
                    >{{ item.translationKey ? (item.translationKey | translate) : item.label }}</a
                    >
                  }
                  @if (isLast || !item?.url) {
                    <span>{{ item.translationKey ? (item.translationKey | translate) : item?.label }}</span>
                  }
                </li>
              }
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
